import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer
} from "recharts";
import * as Sentry from "@sentry/react";
import { useInsights } from "../../hooks/useInsights";

function TendenciasInsightsInner() {
  const userId = (typeof window !== "undefined" && window.__USER_ID__) || "guest";
  const { tools, loading } = useInsights(userId);

  if (loading || !tools) {
    return (
      <div className="insights-panel">
        <h2 className="insights-title">Tendencias</h2>
        <p className="insights-subtitle">Cargando datos…</p>
      </div>
    );
  }

  const data = (tools.tools || []).map((t) => ({
    name: t._id || "Sin clasificar",
    uses: t.count,
  }));

  return (
    <div className="insights-panel">
      <h2 className="insights-title">Tendencias</h2>
      <p className="insights-subtitle">
        Herramientas más utilizadas durante los últimos 30 días.
      </p>

      <div className="insights-card">
        {data.length === 0 ? (
          <p style={{ color: "#9ca3af" }}>
            Aún no hay datos suficientes. Empezá a usar DamyxIA para ver tus tendencias.
          </p>
        ) : (
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={data}>
              <XAxis dataKey="name" stroke="#6b7280" />
              <YAxis stroke="#6b7280" />
              <Tooltip />
              <Bar dataKey="uses" fill="#8b5cf6" />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}

const TendenciasInsights = Sentry.withErrorBoundary(TendenciasInsightsInner, {
  fallback: (
    <div className="insights-panel" data-testid="tendencias-insights-error">
      <h2 className="insights-title">Tendencias</h2>
      <p className="insights-subtitle">
        Ha ocurrido un error al cargar las tendencias. El equipo ya fue notificado.
      </p>
    </div>
  ),
});

export default TendenciasInsights;
